import axios from "~/utils/api";

const customerAccountApi = {
  accssesAccount: () => axios.get("customer/customer-account"),
};

export default customerAccountApi;
